var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"downloadProgressMark"},[_c('div',{staticClass:"progressBar"},[_c('div',{staticClass:"box1"},[_c('div',{staticClass:"jincheng",style:({right:100-parseInt(_vm.currentPage/_vm.totalPages*10000)/100+"%"})})]),_c('div',{staticClass:"box2"},[_vm._v(_vm._s(parseInt(_vm.currentPage/_vm.totalPages*100))+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }